import Header from './Header';

function Notfound() {
    return (
        <div>
            <Header />
            <div class="page">
                <a className="return" href={`${process.env.PUBLIC_URL}/`}><i class="fa-solid fa-left-long"></i></a>
                <h1>404 Not Found</h1>
                <p>お探しのページが見つかりませんでした。</p>
            </div>
        </div>
    )
}

export default Notfound;